import React from "react";
import DealershipCustomDropDown from "../../../../../utils/DealershipCustomDropDown";
import { distanceInKm, squaredDegrees } from "../../../../../utils/distance";

const DealershipSelector = ({
    dealerships = [],
    dealershipsLoading = false,
    userPosition,
    regions,
    brands,
    selectedRegion,
    selectedBrand,
    selectedDealership,
    preselectedDealershipId,
    preselectedRegionValidated,
    preselectedBrandValidated,
    dealershipFilter,
    handleRegionInputChange,
    handleBrandInputChange,
    handleDealershipInputChange,
}) => {
    const byProximity = (a, b) => {
        if (!a.coords || !b.coords) return (a.coords ? 0 : 1) - (b.coords ? 0 : 1);
        return (
            squaredDegrees(userPosition, a.coords) - squaredDegrees(userPosition, b.coords)
        );
    };

    const geoMode = !!userPosition && !preselectedDealershipId && !preselectedBrandValidated;

    const sortedBrands = brands ? [...brands].sort((a, b) => {
        const nameA = a.name ? a.name.toLowerCase() : '';
        const nameB = b.name ? b.name.toLowerCase() : '';
        return nameA.localeCompare(nameB);
    }) : [];

    // Sin ubicación no se reordena: la API ya viene con el orden del admin (sort_order),
    // con Región Metropolitana primero.
    const orderedDealerships = geoMode
        ? [...dealerships].sort(byProximity)
        : userPosition
          ? dealershipFilter().sort(byProximity)
          : dealershipFilter();

    // distance_km lo consume el dropdown para mostrar los km al lado del nombre
    const sortedDealerships = userPosition
        ? orderedDealerships.map((dealership) => ({
              ...dealership,
              distance_km: distanceInKm(userPosition, dealership.coords),
          }))
        : orderedDealerships;

    return (
        <div className="modal-box__contact-form__middle">
            {
                (preselectedRegionValidated || geoMode) ?
                <div className="group-grey">
                    <div className="group-grey__heading">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="16" fill="#E6E6E6"/>
                        <g clipPath="url(#clip0_4547_21901)">
                        <path d="M16.0026 9.33337C13.4226 9.33337 11.3359 11.42 11.3359 14C11.3359 16.78 14.2826 20.6134 15.4959 22.0734C15.7626 22.3934 16.2493 22.3934 16.5159 22.0734C17.7226 20.6134 20.6693 16.78 20.6693 14C20.6693 11.42 18.5826 9.33337 16.0026 9.33337ZM16.0026 15.6667C15.0826 15.6667 14.3359 14.92 14.3359 14C14.3359 13.08 15.0826 12.3334 16.0026 12.3334C16.9226 12.3334 17.6693 13.08 17.6693 14C17.6693 14.92 16.9226 15.6667 16.0026 15.6667Z" fill="#292929"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_4547_21901">
                        <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
                        </clipPath>
                        </defs>
                        </svg>
                        <p className="nunito-16">Elige una sucursal</p>
                    </div>
                    <DealershipCustomDropDown
                        isDisabled={geoMode ? false : !selectedBrand?.id}
                        isLoading={dealershipsLoading}
                        selectedOption={selectedDealership}
                        label="Sucursal"
                        items={sortedDealerships}
                        onClickOption={(e) => handleDealershipInputChange(e)}
                        initialValue="Sucursal"
                    />
                </div> :
                <>
                    <div className="group-grey --no-border-bottom">
                        <div className="group-grey__heading">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="32" height="32" rx="16" fill="#E6E6E6"/>
                                <g clipPath="url(#clip0_4547_21901)">
                                <path d="M16.0026 9.33337C13.4226 9.33337 11.3359 11.42 11.3359 14C11.3359 16.78 14.2826 20.6134 15.4959 22.0734C15.7626 22.3934 16.2493 22.3934 16.5159 22.0734C17.7226 20.6134 20.6693 16.78 20.6693 14C20.6693 11.42 18.5826 9.33337 16.0026 9.33337ZM16.0026 15.6667C15.0826 15.6667 14.3359 14.92 14.3359 14C14.3359 13.08 15.0826 12.3334 16.0026 12.3334C16.9226 12.3334 17.6693 13.08 17.6693 14C17.6693 14.92 16.9226 15.6667 16.0026 15.6667Z" fill="#292929"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_4547_21901">
                                <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <p>Elige una sucursal</p>
                        </div>
                    </div>

                    <div className="group-grey__inputs">
                        <DealershipCustomDropDown
                            selectedOption={preselectedBrandValidated && !preselectedDealershipId ? {} : selectedRegion}
                            label="Región"
                            items={regions}
                            isDisabled={preselectedRegionValidated || geoMode}
                            onClickOption={(e) => handleRegionInputChange(e)}
                            initialValue="Región"
                        />
                        <DealershipCustomDropDown
                            isDisabled={!selectedRegion?.id || preselectedBrandValidated || geoMode}
                            selectedOption={selectedBrand}
                            label="Concesionario"
                            items={sortedBrands}
                            onClickOption={(e) => handleBrandInputChange(e)}
                            initialValue="Concesionario"
                        />
                        <DealershipCustomDropDown
                            isDisabled={geoMode ? false : !selectedBrand?.id}
                            isLoading={dealershipsLoading}
                            selectedOption={selectedDealership}
                            label="Sucursal"
                            items={sortedDealerships}
                            onClickOption={(e) => handleDealershipInputChange(e)}
                            initialValue="Sucursal"
                        />
                    </div>
                </>
            }
        </div>
    );
};

export default DealershipSelector;
